// 外观模块
export default {
    Appearance: {
        MobilePhone: '手机',
        Computer: '电脑',
        AppearanceSettings: '外观设置',
        Header: '页眉',
        ShowHeader: '显示页眉',
        HeaderType: '页眉类型',
        Writing: '文字',
        Single: '单图',
        TextContent: '文字内容',
        PleaseEnterContent: '请输入内容',
        FontSettings: '字体设置',
        Align: '对齐方式',
        LeftJustifying: '左对齐',
        Center: '居中',
        RightAlignment: '右对齐',
        bgColor: '背景颜色',
        HeaderImage: '页眉图片',
        AddPicture: '添加图片',
        Background: '背景',
        BackgroundSettings: '背景设置',
        Pictures: '上传图片',
        ChooseAColor: '选择颜色',
        BackgroundImage: '背景图片',
        BackgroundPosition: '背景位置',
        Tile: '平铺',
        BackgroundTransparency: '底色透明度',
        LogoSettings: 'logo设置',
        LogoLocation: 'logo位置',
        ProjectTitle: '项目标题',
        WelcomeMessage: '欢迎语',
        Stem: '题干',
        Option: '选项',
        Conclusion: '结束语',
        ButtonSettings: '按钮设置',
        SubmitButtonText: '提交按钮文字',
        DisplaySettings: '显示设置',
        ShowHeading: '显示标题',
        ShowWelcomeMessage: '显示欢迎语',
        DisplayQuestionNumber: '显示题目序号',
        SubmitTo: '提交'
    },
  };